import {Record, List} from 'immutable';

import BehaviorsCollection from 'web-app/behaviors/behaviors-collection';

import {type IOpeningHours, type IChildRelation, OpeningHours, ChildRelation, Institution} from './shared';

export interface ChildCheckinExtendedResponse {
    behaviors: any[];
    child: any;
    childCheckin: any;
    institution: any;
    openingHours: IOpeningHours;
    relations: IChildRelation[];
}

export class ExtendedChildCheckin extends Record<{
    autoCheckedOut: boolean;
    checkinLoginId: string;
    checkinTime: string;
    checkoutLoginId: string;
    checkoutTime: string | null;
    childCheckinId: string;
    childId: string;
    deletedAt: string | null;
    goHomeWithChildId: string;
    groupId: string;
    hours: string | null;
    institutionId: string;
    pickupRelationId: string;
    pickupTime: string;
    openingHours: OpeningHours;
    relations: List<ChildRelation>;
    institution: Institution;
    behaviors: BehaviorsCollection;
    name: string;
    image: string;
    requirePickupInfo: boolean;
    checkedIn?: boolean;
}>({
    autoCheckedOut: false,
    checkinLoginId: '',
    checkinTime: '',
    checkoutLoginId: '',
    checkoutTime: '',
    childCheckinId: '',
    childId: '',
    deletedAt: '',
    goHomeWithChildId: '',
    groupId: '',
    hours: null,
    institutionId: '',
    pickupRelationId: '',
    pickupTime: '',
    openingHours: new OpeningHours(),
    relations: List(),
    institution: new Institution(),
    behaviors: new BehaviorsCollection([]),
    name: '',
    image: '',
    requirePickupInfo: false,
}) {}

const fromAPI = (data: ChildCheckinExtendedResponse) => {
    return new ExtendedChildCheckin({
        ...data.childCheckin,
        openingHours: new OpeningHours(data.openingHours),
        relations: List(data.relations.map(r => new ChildRelation(r))),
        institution: new Institution(data.institution),
        behaviors: new BehaviorsCollection(data.behaviors),
        name: data.child.firstName,
        image: data.child.image,
        requirePickupInfo: data.child.requirePickupInfo,
        childId: data.child.childId,
        goHomeWithChildId: data.childCheckin?.goHomeWithChildId,
    });
};

export default {
    record: ExtendedChildCheckin,
    default: new ExtendedChildCheckin(),
    fromAPI,
};
